import { ACTION_STATES, ComplexAction, createHandler, createReducer, DefaultAction } from "core/actions";
import { cloneDeep } from "lodash";

export const ASSET_STATUS = {
    UPLOADING: "UPLOADING",
    UPLOADED: "UPLOADED",
    FAILED_UPLOAD: "FAILED_UPLOAD",
};
export const initState = {
    batchStatus: ACTION_STATES.NO_REQUEST,
    assetBatch: {},
    assetsFailed: [],
};

export class UPLOAD_BATCH_ASSETS extends ComplexAction {
    sendRdx(state, { payload }) {
        const { files } = payload;
        const assetBatch = {
            ...state.assetBatch,
        };
        files.map((f) => {
            assetBatch[f.id] = {
                status: ASSET_STATUS.UPLOADING,
                progress: 0,
            };
        });
        return Object.assign({}, state, {
            assetBatch,
            batchStatus: ACTION_STATES.SEND,
        });
    }

    successRdx(state) {
        
        
        
        
        return Object.assign({}, state, {
            batchStatus: ACTION_STATES.SUCCESS,
        });
    }

    failedRdx(state, { payload }) {
        return Object.assign({}, state, {
            batchStatus: ACTION_STATES.FAILED,
            error: payload.error,
        });
    }
}

export class UPDATE_ASSET_PROGRESS extends DefaultAction {
    callRdx(state, { payload }) {
        const assetBatch = cloneDeep(state.assetBatch);
        assetBatch[payload.id].progress = payload.progress;
        if (payload.status) {
            assetBatch[payload.id].status = payload.status;
        }
        return Object.assign({}, state, { assetBatch });
    }
}
export class UPDATE_ASSET_STATUS extends DefaultAction {
    callRdx(state, { payload }) {
        const { id, status } = payload;
        const assetBatch = cloneDeep(state.assetBatch);
        if (!assetBatch[id]) {
            return state;
        } else {
            assetBatch[id].status = status;
            return Object.assign({}, state, {
                assetBatch,
            });
        }
    }
}

export const actions = {
    UPLOAD_BATCH_ASSETS: new UPLOAD_BATCH_ASSETS(),
    UPDATE_ASSET_PROGRESS: new UPDATE_ASSET_PROGRESS(),
    UPDATE_ASSET_STATUS: new UPDATE_ASSET_STATUS(),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);
